/**
 * This class is used to wrap provider agents (e.g., New Relic, Segment, Grafana Faro, etc.).
 */
export class AnalyticsAgent {
    /** Prevents `collectingNonEssentials` from causing infinite reload bomb */
    private collectingNonEssentials: boolean;

    constructor(_config: Record<string, unknown>) {
        this.collectingNonEssentials = false;
    }

    public collectNonEssentials() {
        this.collectingNonEssentials = true;
        this.collect();

        return this;
    }

    public collectOnlyEssentials() {
        if (this.collectingNonEssentials && typeof window !== 'undefined') {
            window.location.reload();
        }
    }

    private collect() {
        console.warn('AnalyticsAgent.collect is not implemented');
    }
}
